import { useQuery } from "@tanstack/react-query";
import { usersApi } from "@/lib/users.api";
import { queryKeys } from "@/lib/query-keys";

// Backs every "Employé responsable" picker — manager+ (not admin-only like
// the full /users list), minimal fields only.
export function useOperationalDirectory() {
  return useQuery({
    queryKey: queryKeys.operationalDirectory(),
    queryFn: () => usersApi.directory().then((r) => r.data),
    staleTime: 5 * 60 * 1000,
  });
}
